import { createContext } from '@fountain/fountain-ui-components';
import React, { useMemo, useState } from 'react';

import { failedToImplement } from '../context';

const FIELD_ENHANCEMENT_OPTION_STATE_DEFAULTS = {
  applyRegexValidation: false,
};

type FieldEnhancementOptionsStateContext =
  typeof FIELD_ENHANCEMENT_OPTION_STATE_DEFAULTS;

export const [
  FieldEnhancementOptionsStateContextProvider,
  useFieldEnhancementOptionsContextState,
] = createContext<FieldEnhancementOptionsStateContext>({
  defaultValue: FIELD_ENHANCEMENT_OPTION_STATE_DEFAULTS,
});

export const [
  FieldEnhancementOptionsApiContextProvider,
  useFieldEnhancementOptionsApiContext,
] = createContext<{
  resetFieldEnhancementOptions: () => void;
  toggleEnhancement: (key: keyof FieldEnhancementOptionsStateContext) => void;
  setApplyRegexValidationEnabled: () => void;
}>({
  defaultValue: {
    resetFieldEnhancementOptions: failedToImplement(
      'resetFieldEnhancementOptions',
    ),
    toggleEnhancement: failedToImplement('toggleEnhancement'),
    setApplyRegexValidationEnabled: failedToImplement(
      'setApplyRegexValidationEnabled',
    ),
  },
});

export const FieldEnhancementOptionsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [fieldEnhancementOptions, setFieldEnhancementOptions] =
    useState<FieldEnhancementOptionsStateContext>(
      FIELD_ENHANCEMENT_OPTION_STATE_DEFAULTS,
    );

  const api = useMemo(
    () => ({
      resetFieldEnhancementOptions: () => {
        setFieldEnhancementOptions(FIELD_ENHANCEMENT_OPTION_STATE_DEFAULTS);
      },
      toggleEnhancement: (key: keyof FieldEnhancementOptionsStateContext) => {
        setFieldEnhancementOptions(prev => ({
          ...prev,
          [key]: !prev[key],
        }));
      },
      setApplyRegexValidationEnabled: () =>
        setFieldEnhancementOptions(prev => ({
          ...prev,
          applyRegexValidation: true,
        })),
    }),
    [],
  );

  return (
    <FieldEnhancementOptionsApiContextProvider value={api}>
      <FieldEnhancementOptionsStateContextProvider
        value={fieldEnhancementOptions}
      >
        {children}
      </FieldEnhancementOptionsStateContextProvider>
    </FieldEnhancementOptionsApiContextProvider>
  );
};
